import React, { useRef, useEffect } from 'react';
import { usePreproductPreviewContext } from './context/Context';
import styled from 'styled-components';
import { Iframe } from './Iframe';
import { Overlay } from './Overlay';
import { PREPROD_PREVIEW_ACTIONS } from './context/types';
import { BackButton } from './BackButton';
import { useModalTransition } from './hooks/useModalTransition';
import { useFullscreenListener } from './hooks/useFullscreenListener';
import { useBoardCreatedListener } from './hooks/useBoardCreatedListener';
import { fullscreenStatusEvent } from './context/actions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var BoardContainer = styled.div.withConfig({
  displayName: "Board__BoardContainer",
  componentId: "sc-1nsliqa-0"
})(["position:relative;width:100%;height:", ";background-color:var(--wcds-colors-white);border-radius:4px;overflow:hidden;display:flex;flex-direction:column;align-items:center;justify-content:center;transition:height 0.3s ease-in-out;"], function (_ref) {
  var isVisible = _ref.isVisible;
  return isVisible ? '100%' : 0;
});
var BoardComponent = styled.div.attrs({
  'data-testid': 'preproduct-preview-board-container'
}).withConfig({
  displayName: "Board__BoardComponent",
  componentId: "sc-1nsliqa-1"
})(["z-index:", ";border-radius:4px;overflow:hidden;position:absolute;top:0;right:0;bottom:0;left:0;transition:top 0.3s ease-in-out,bottom 0.3s ease-in-out,left 0.3s ease-in-out,right 0.3s ease-in-out,z-index 0.3s step-end;"], function (_ref2) {
  var modal = _ref2.modal;
  return modal ? 999 : 0;
});
export var Board = function Board() {
  var _usePreproductPreview = usePreproductPreviewContext(),
      dispatch = _usePreproductPreview.dispatch,
      boardContainerState = _usePreproductPreview.boardContainerState,
      boardContainerConfig = _usePreproductPreview.boardContainerConfig,
      iframeState = _usePreproductPreview.iframeState;

  useFullscreenListener();
  useBoardCreatedListener(boardContainerState.editableTemplates.templateKey);
  var boardRef = useRef(null);

  var _useModalTransition = useModalTransition(boardRef.current, iframeState.iframeRef),
      openModalTransition = _useModalTransition.openModalTransition,
      closeModalTransition = _useModalTransition.closeModalTransition;

  useEffect(function () {
    if (boardContainerState.boardContainerDisplayMode === 'inline') {
      fullscreenStatusEvent(iframeState.iframeRef, false);
      closeModalTransition();
    }

    if (boardContainerState.boardContainerDisplayMode === 'modal') {
      fullscreenStatusEvent(iframeState.iframeRef, true);
      openModalTransition();
    }
  }, [boardContainerState.boardContainerDisplayMode]);
  var isContainerVisible = boardContainerState.boardContainerDisplayMode === 'inline' || boardContainerConfig.initialMode === 'inline';
  var isModalOpen = boardContainerState.boardContainerDisplayMode === 'modal';

  var toggleModal = function toggleModal(e) {
    e.stopPropagation();
    dispatch({
      type: PREPROD_PREVIEW_ACTIONS.TOGGLE_MODAL
    });
  };

  return /*#__PURE__*/_jsxs(BoardContainer, {
    isVisible: isContainerVisible,
    children: [/*#__PURE__*/_jsx(Overlay, {
      isVisible: isModalOpen
    }), /*#__PURE__*/_jsxs(BoardComponent, {
      modal: isModalOpen,
      ref: boardRef,
      children: [/*#__PURE__*/_jsx(Iframe, {
        templateKey: boardContainerState.editableTemplates.templateKey
      }), /*#__PURE__*/_jsx(BackButton, {
        isVisible: isModalOpen,
        onClick: toggleModal
      })]
    })]
  });
};